import React from 'react'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import { useMe } from 'src/core/graphql/hooks'
import { useGlobalState } from 'src/sites/state'

const UserAccountControl = ({ display }) => {
   const { theme } = useGlobalState()
   const { me, loading, isLoggedIn } = useMe()

   return (
      <View display={display}>
         {!loading && !isLoggedIn && (
            <NavLink to="/login">
               <Text
                  color={theme.tmpMainMenuTextColor}
                  size={theme.headerMainMenuActionBlockTextSize}
                  weight="medium">
                  Sign in
               </Text>
            </NavLink>
         )}
         {isLoggedIn && (
            <NavLink to="/-/profile">
               <View display="flex" alignItems="center">
                  <Text
                     color={theme.tmpMainMenuTextColor}
                     size={theme.headerMainMenuActionBlockTextSize}
                     weight="medium">
                     {me.firstName}
                  </Text>
               </View>
            </NavLink>
         )}
      </View>
   )
}

UserAccountControl.propTypes = {
   display: PropTypes.string
}

UserAccountControl.defaultProps = {
   display: 'none[a-c] block[d-f]'
}

export default React.memo(UserAccountControl)
